import { Reveal, MaskedLine } from "@/components/Reveal";
import { ThreadArt } from "@/components/ThreadArt";
import { EditorialMarquee } from "@/components/Marquee";
import { PILLARS } from "@/data/pillars";
import { useSEO } from "@/components/Seo";
import { Sigil } from "@/components/Sigil";
import { eyebrow } from "@/lib/styles";

export default function Pillars() {
  useSEO(
    "The Six Pillars | Threads Unbound™",
    "Freedom, Chaos, Truth, Grit, Rebellion, Wisdom: the six pillars every Threads Unbound™ piece is built on."
  );

  return (
    <main data-testid="pillars-page">
      <header className="px-6 pb-24 pt-36 md:px-12 md:pt-44 lg:px-20">
        <MaskedLine>
          <span className={eyebrow}>The manifesto</span>
        </MaskedLine>
        <h1 className="mt-6 font-serif leading-[0.95] tracking-tighter">
          <MaskedLine delay={0.15}>
            <span className="block text-5xl font-light sm:text-6xl lg:text-7xl">
              Six threads. <span className="italic text-[#D4AF37]">One weave.</span>
            </span>
          </MaskedLine>
        </h1>
        <Reveal delay={0.3}>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-white/60">
            Six things most of us live through. They hold in cloth and in life. Read them like chapters. Wear them like vows.
          </p>
        </Reveal>
      </header>

      {PILLARS.map((p, i) => (
        <section
          key={p.name}
          data-testid={`pillar-chapter-${p.name.toLowerCase()}`}
          className="relative overflow-hidden border-t border-white/10 px-6 py-24 md:px-12 md:py-32 lg:px-20"
        >
          <span
            aria-hidden="true"
            className="pointer-events-none absolute -top-6 right-2 select-none font-serif text-[26vw] font-light leading-none text-white/[0.04] md:text-[16vw]"
          >
            {p.num}
          </span>
          <div className={`relative grid items-center gap-14 md:grid-cols-2 ${i % 2 === 1 ? "" : ""}`}>
            <Reveal className={i % 2 === 1 ? "md:order-2" : ""}>
              <Sigil pillar={p.name} size={88} className="mb-10" />
              <p className="font-serif text-sm tracking-[0.3em] text-[#D4AF37]/80">CHAPTER {p.num}</p>
              <h2 className="mt-4 font-serif text-5xl font-light tracking-tight md:text-6xl">{p.name}</h2>
              <p className="mt-4 font-serif text-xl italic text-[#D4AF37] md:text-2xl">{p.essence}</p>
              <p className="mt-6 max-w-md text-base leading-relaxed text-white/60">{p.body}</p>
            </Reveal>
            <Reveal delay={0.15} className={i % 2 === 1 ? "md:order-1" : ""}>
              <div className="aspect-[4/3] overflow-hidden border border-white/10">
                <ThreadArt seed={`pillar-${p.name.toLowerCase()}`} lines={9} stars={30} className="h-full w-full" />
              </div>
            </Reveal>
          </div>
        </section>
      ))}

      <EditorialMarquee items={["01 FREEDOM", "02 CHAOS", "03 TRUTH", "04 GRIT", "05 REBELLION", "06 WISDOM"]} />
    </main>
  );
}
